module.exports = __webpack_public_path__ + "static/9-45fc795bfd8bffc94391af6c161f8cef.jpg";